import React from 'react';
import { Tooltip } from 'antd';

const tooltipOverrides: Record<string, string> = {
    'SME Allocation (%)': 'Time spent on eligible R&D activities - please add a %. If you do not have an exact figure, a ball park figure will do.',
};

export default function PrimaryTooltip(props: any) {
    const shouldOverride =
        (props.title === 'prompt text' || !props.title) && tooltipOverrides[props.text];
    const tooltipTitle = shouldOverride ? tooltipOverrides[props.text] : props.title;

    return (
        <Tooltip
            title={tooltipTitle}
            color={'#f48028'}
            arrowPointAtCenter
            placement={props.placement || 'top'}
        >
            <span style={props.style}>{props.text}</span>
        </Tooltip>
    );
}
